import { put, takeEvery, call } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { InviteMC, ResendMCInvite, RejectMCInvite } from 'src/constants/actionTypes'
import { Endpoints } from 'src/constants/endpoints'
import { ApiService, callSecureApi } from '../api/callApi'

interface InviteMCRequest {
  firstName: string
  lastName: string
  companyName: string
  email: string
}

function* onInviteMC(action: AsyncAction<InviteMCRequest, { id: string }>) {
  const { firstName, lastName, email, companyName } = action.payload

  try {
    yield call(callSecureApi, Endpoints.InviteMC, {
      method: 'POST',
      apiService: ApiService.Paraworks,
      body: {
        ownerFirstName: firstName,
        ownerLastName: lastName,
        companyName: companyName,
        ownerEmail: email,
        type: 'master_contractor',
      },
    })

    yield put(InviteMC.success())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to invite master contractor'

    yield put(InviteMC.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

interface ResendMCInviteRequest {
  masterContractorId?: string
  inviteId?: string
}

function* onResendMCInvite(action: AsyncAction<ResendMCInviteRequest, { id: string }>) {
  const { masterContractorId, inviteId } = action.payload

  try {
    yield call(callSecureApi, Endpoints.ResendMCInvite, {
      method: 'POST',
      apiService: ApiService.Paraworks,
      body: {
        masterContractorId,
        inviteId,
      },
    })

    yield put(ResendMCInvite.success())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to resend invite to master contractor'

    yield put(ResendMCInvite.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

interface RejectMCInviteRequest {
  masterContractorRelationId?: string
  inviteId?: string
}

function* onRejectMCInvite(action: AsyncAction<RejectMCInviteRequest, { id: string }>) {
  const { masterContractorRelationId, inviteId } = action.payload

  try {
    yield call(callSecureApi, Endpoints.RejectMCInvite, {
      method: 'POST',
      apiService: ApiService.Paraworks,
      body: {
        masterContractorRelationId,
        inviteId,
      },
      returnResponse: true,
    })

    yield put(RejectMCInvite.success())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to reject master contractor'

    yield put(RejectMCInvite.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* inviteMCSaga() {
  yield takeEvery(InviteMC.type.REQUEST, onInviteMC)
  yield takeEvery(ResendMCInvite.type.REQUEST, onResendMCInvite)
  yield takeEvery(RejectMCInvite.type.REQUEST, onRejectMCInvite)
}
